<template>
    <div class="container">
        <div class="row">
            <el-steps :active="active_step">
                <el-step v-for="(step,index) in steps" v-bind:key="step.name" v-bind:title="step.label">{{ step.label }}</el-step>
            </el-steps>
            <el-button style="margin-top: 12px;" @click="previousStep">Previous step</el-button>
            <el-button style="margin-top: 12px;" @click="nextStep">Next step</el-button>
        </div>
        <div class="row" style="margin-top:32px;">
            <div class="panel panel-default">
                <div class="panel-body" v-show="this.active_step_name == 'members'">
                    <h1>Account Members</h1>
                    <p>The table below shows the members linked to your account. Please check the details and update them if required.</p>
                    <el-alert
                            title="Important Note"
                            description="Please note that names must match those registered with your national governing body"
                            type="warning"
                            :closable="false">
                    </el-alert>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Membership Number</th>
                                <th>First Name</th>
                                <th>Known As</th>
                                <th>Last Name</th>
                                <th>Date of Birth</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr  v-for="(member,index) in account.members" v-if="account.members.length > 0" v-bind:class="{ 'bg-success' : account.my_member_id == member.id }">
                                <td><p class="form-control-static input-lg">{{ member.asa_number }}</p></td>
                                <td><input type="text" class="form-control input-lg" v-model="member.first_name"></td>
                                <td><input type="text" class="form-control input-lg" v-model="member.known_as"></td>
                                <td><input type="text" class="form-control input-lg" v-model="member.last_name"></td>
                                <td>
                                    <datepicker2 v-model="member.date_of_birth" inputClasses="input-lg" valueFormat="yyyy-mm-dd" displayFormat="dd/mm/yyyy" placeholder="Date of Birth"/>
                                <td>
                                </td>
                                <td>
                                    <swm-button :colour="account.my_member_id != member.id ? 'success' : 'outline-success'" @click="setMyMember(member)">This is Me</swm-button>
                                </td>
                            </tr>
                        </tbody>

                    </table>

                </div>
                <div class="panel-body" v-show="this.active_step_name == 'contact'">
                    <el-table :data="this.account.members" stripe border >
                        <el-table-column label="First Name">
                            <template slot-scope="scope">
                                <p>{{ scope.row.first_name }} {{ scope.row.last_name }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="phone" label="Home Phone" >
                            <template slot="header" slot-scope="scope">
                                <i class="el-icon-phone"></i>&nbsp;Phone
                            </template>
                            <template slot-scope="scope">
                                <el-form label-position="right" label-width="100px">
                                    <el-form-item label="Home">
                                        <el-input v-model="scope.row.phone" prefix-icon="el-icon-phone" placeholder="Home Phone">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="Mobile" prefix-icon="el-icon-mobile-phone" placeholder="Mobile Phone">
                                        <el-input v-model="scope.row.mobile_phone">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="Work" prefix-icon="el-icon-phone" placeholder="Work Phone">
                                        <el-input v-model="scope.row.work_phone">
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column prop="email" label="Email">
                            <template slot-scope="scope">
                                <el-form label-width="100px" label-position="right">
                                    <el-form-item label="Main" prefix-icon="el-icon-mail" placeholder="Main Email">
                                        <el-input v-model="scope.row.email">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="Work" prefix-icon="el-icon-phone" placeholder="Work Email">
                                        <el-input v-model="scope.row.work_email">
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="panel-body" v-show="this.active_step_name == 'emergency'">
                    <h1>This is the emergency panel</h1>
                </div>
                <div class="panel-body" v-show="this.active_step_name == 'medical'">
                    <h1>This is the medical panel</h1>
                </div>
                <div class="panel-body" v-show="this.active_step_name == 'consent'">
                    <h1>This is the consent panel</h1>
                </div>
                <div class="panel-body" v-show="this.active_step_name == 'custom'">
                    <h1>This is the custom panel</h1>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import { DatePicker, Message, Icon, Tooltip, Loading } from 'element-ui';
    import lang from 'element-ui/lib/locale/lang/en';
    import locale from 'element-ui/lib/locale';
    locale.use(lang);

    export default {
        components: { DatePicker, Message, Tooltip, Icon, Loading },
        props: {
            account_id: {
                type: Number,
                required: true
            },
            show_emergency: {
                type: Boolean,
                default: false
            },
            show_medical:  {
                type: Boolean,
                default: false
            },
            show_consent:  {
                type: Boolean,
                default: false
            },
            show_custom:  {
                type: Boolean,
                default: false
            },
            allow_new_members:  {
                type: Boolean,
                default: false
            }
        },

        data: function () {
            return {
                account: {},
                active_step_name: "members",
                active_step: 0,
                steps: [],
                number_of_steps: 0
            };
        },
        computed: {
            memberRowStyle: function(member_id) {
                if (this.account.my_member_id == member_id) {
                    return 'bg-success';
                }
            }
        },
        mounted() {
            console.log('Registration component mounted.');
            this.setupDefaults();
            this.getAccountData();
        },
        methods: {
            setupDefaults() {
                console.log('Setting defaults');
                this.setupSteps();
            },
            setupSteps() {
                console.log(this.$props);
                this.steps = [
                    {
                        name: 'members',
                        label: 'Members',
                        confirmed: false
                    },
                    {
                        name: 'contact',
                        label: 'Contact Details',
                        confirmed: false
                    },
                ];
                if (this.show_emergency) {
                    this.steps.push({name: 'emergency', label: 'Emergency Contacts', confirmed: false});
                }
                if (this.show_medical) {
                    this.steps.push({name: 'medical', label: 'Medical Details', confirmed: false});
                }
                if (this.show_consent) {
                    this.steps.push({name: 'consent', label: 'Consent', confirmed: false});
                }
                if (this.show_custom) {
                    this.steps.push({name: 'custom', label: 'Additional Details', confirmed: false});
                }
                this. number_of_steps = this.steps.length;
            },

            getAccountData(id) {
                console.log('getAccountData');

                var training_date= moment(this.selectedDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                axios.get('/account/api/review').then((response) => {
                    console.log(response.data);
                    this.account = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading your account details.', type: 'error'});
                });

            },
            setSection(sectionName) {
                this.active_step_name = sectionName;
            },
            handleClick()
            {},
            nextStep() {
                this.active_step++;
                if (this.active_step >= this.number_of_steps) this.active_step = this.number_of_steps - 1;
                this.active_step_name = this.steps[this.active_step].name;
            },
            previousStep() {
                this.active_step--;
                if (this.active_step < 0) this.active_step = 0;
                this.active_step_name = this.steps[this.active_step].name;
            },
            setMyMember(member) {

                console.log(member);
                console.log('Before');
                console.log(member.id);
                console.log(this)
                console.log(this.account);
              this.account.my_member_id = member.id;
                console.log('After');
                console.log(member.id);
                console.log(this.account.my_member_id);


            },
            isMyMember(member) {
                return (member.id == this.account.my_member_id);
            },
            saveAccountData() {
                console.log('saveAccountData.');
                axios.put('/api/v1/training_session_member/' + training_session_member.id, {
                    training_session_member,
                }).then((response) => {
                    // this.loadingInstance.close();
                    console.log(response.data);

                    this.$set(training_session_member, 'savedSuccess', true);
                    setTimeout(() => {
                        this.$set(training_session_member, 'savedSuccess', null);
                        // training_session_member.savedSuccess = null;
                    }, 2000);
                    // this.$message({message: 'The training session attendance for ' + training_session_member.member.name + ' was saved successfully.', type: 'success'});

                }).catch((error) => {
                    // this.loadingInstance.close();
                    this.handleHTTPError(error);
                    this.$set(training_session_member, 'savedSuccess', false);
                    // this.$message({message: 'There was a problem saving the training session attendance for ' + training_session_member.member.name, type: 'error'});
                });
            },
            handleHTTPError(error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data); // Error message
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    // this.$message({message: 'Error: ' + error.response.data, type: 'error'});
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                    // this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    // this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
                }
                console.log(error.config);
            },
        }
    }
</script>